export default "__VITE_ASSET__QorhO1Kt__"